export default {
      id: "close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#close",
      toString: function () {
        return this.url;
      }
    }